(() => {
  const script = document.currentScript;
  const locale = (document.documentElement.lang || window.Shopify?.locale || 'en')
    .toLowerCase()
    .split('-')[0];
  const country = (
    window.Shopify?.country || window.Shopify?.localization?.country?.iso_code || ''
  ).toUpperCase();
  const isUsEnglish = locale === 'en' && country === 'US';
  const usProductImage = script?.dataset.nuyvaUsProductImage || '';
  const usTrustImage = script?.dataset.nuyvaUsTrustImage || '';
  const cartEnglishPack = script?.dataset.nuyvaCartEnglishPack === 'true';
  const cartProductImage = script?.dataset.nuyvaCartProductImage || '';
  const cartProductTitle = script?.dataset.nuyvaCartProductTitle || '';
  const cartPackLabel = script?.dataset.nuyvaCartPackLabel || '';
  const embed = document.querySelector('essential-cart-app-embed[upsell-app-data]');

  // Presentation only: never mutate cart data, prices, app state or quantities.
  function alignEnglishCartPack() {
    if (!cartEnglishPack || !cartProductImage || !cartProductTitle || !cartPackLabel) return;
    const root = document.querySelector('#essential-cart-drawer-portal');
    if (!root) return;

    for (const line of root.querySelectorAll('[data-essential-cart-element="cart-drawer-item-frame"]')) {
      const title = line.querySelector('[data-essential-cart-element="line-item-title"]');
      if (!title) continue;
      let url;
      try {
        url = new URL(title.href, window.location.origin);
      } catch {
        continue;
      }
      if (url.origin !== window.location.origin || url.searchParams.get('variant') !== '66907304919344') continue;
      const oldTitle = title.textContent.trim();
      const variant = line.querySelector('[data-essential-cart-element="line-item-variant-title"]');
      const oldVariant = variant?.textContent.trim() || '';
      const oldFullTitle = oldVariant ? `${oldTitle} - ${oldVariant}` : oldTitle;

      // Guard every write: the app re-renders and our existing observer sees child changes.
      if (title.textContent !== cartProductTitle) title.textContent = cartProductTitle;
      if (variant && variant.textContent !== cartPackLabel) variant.textContent = cartPackLabel;
      const image = line.querySelector('img[data-essential-cart-element="line-item-image"]');
      if (image && image.getAttribute('src') !== cartProductImage) {
        replaceLocalizedImage(image, cartProductImage, cartProductTitle);
      }
      for (const element of [line, ...line.querySelectorAll('[aria-label]')]) {
        const label = element.getAttribute('aria-label');
        if (!label || !oldTitle || oldTitle === cartProductTitle) continue;
        const aligned = label.replace(oldFullTitle, `${cartProductTitle} - ${cartPackLabel}`).replace(oldTitle, cartProductTitle);
        if (aligned !== label) element.setAttribute('aria-label', aligned);
      }
    }
  }

  function replaceLocalizedImage(image, source, alt, objectPosition) {
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = source;
    if (alt) image.alt = alt;
    if (objectPosition) image.style.objectPosition = objectPosition;
  }

  function localizeUsImages() {
    if (!isUsEnglish) return;

    document.querySelectorAll('img').forEach((image) => {
      const source = [image.currentSrc, image.getAttribute('src'), image.getAttribute('srcset')]
        .filter(Boolean)
        .join(' ');

      if (usProductImage && source.includes('/nuyva5_chiffon.jpg')) {
        replaceLocalizedImage(image, usProductImage, 'Nuyva AquaFibre™ — 5 microfiber cloths');
      } else if (usTrustImage && source.includes('/trsut_nuyva.jpg')) {
        replaceLocalizedImage(image, usTrustImage, '', 'right center');
      }
    });
  }

  function mergeTranslation(resource, localeCode, fallbackContent) {
    if (!resource) return;

    const translations = Array.isArray(resource.contentTranslations)
      ? resource.contentTranslations
      : [];
    const current = translations.find((translation) => translation.locale === localeCode);

    if (current) {
      current.content = { ...fallbackContent, ...(current.content || {}) };
    } else {
      translations.push({ locale: localeCode, content: fallbackContent });
    }

    resource.contentTranslations = translations;
  }

  if (embed && locale === 'fr') {
    try {
      const payload = JSON.parse(embed.getAttribute('upsell-app-data'));

      (payload.carts || []).forEach((cart) => {
        mergeTranslation(cart, 'fr', {
          buttonBodyHtml: 'Passer au paiement · {price}',
          buttonBodyHtmlMobile: 'Passer au paiement · {price}',
          disabledButtonBodyHtml: 'Épuisé',
          disabledButtonBodyHtmlMobile: 'Épuisé',
          emptyCartBodyHtml: '<p><span style="white-space: pre-wrap;">Votre panier est vide.</span></p>',
          emptyCartButtonText: 'Continuer mes achats',
          cartTitle: 'Panier • {item_count}',
          subtotalLabel: 'Sous-total',
          orderNoteText: 'Ajouter une note',
          orderNoteFieldLabelText: 'Instructions spéciales pour le transporteur',
          orderNoteButtonText: 'Enregistrer',
          orderNoteValidationMessage: 'Les instructions doivent être renseignées pour passer au paiement',
          discountsFieldLabelText: 'Code promo',
          discountsIncorrectCodeText: 'Code non applicable',
          discountsCantApplyText: '{discount} non applicable',
          discountsButtonText: 'Ajouter',
          discountsLinkText: 'Ajouter un code promo',
          discountsSavingsLabelText: 'Économies',
          upsellsTitleText: 'Vous aimerez aussi',
          subscriptionPlanTextTemplate: 'Livré tous les {delivery} {interval}',
          subscriptionUpgradeButtonText: "S'abonner et économiser",
          subscriptionIntervalDayLabel: 'jour(s)',
          subscriptionIntervalWeekLabel: 'semaine(s)',
          subscriptionIntervalMonthLabel: 'mois',
          subscriptionIntervalYearLabel: 'année(s)',
          subscriptionOneTimePurchaseLabel: 'Achat unique',
        });

        (cart.upsells || []).forEach((upsell) => {
          mergeTranslation(upsell, 'fr', {
            titleText: 'Pour une cuisine propre et toujours sèche',
            buttonText: 'Ajouter',
            discountMessage: 'Tapis Nuyva : 10 % de réduction avec vos chiffons',
          });
        });
      });

      embed.setAttribute('upsell-app-data', JSON.stringify(payload));
    } catch (error) {
      console.warn('[Nuyva] Essential Cart locale data could not be prepared.', error);
    }
  }

  function localizeEssentialCartNavigation() {
    localizeUsImages();
    alignEnglishCartPack();
    const localizedCollectionsUrl = locale === 'en' ? '/en/collections/all' : '/collections/all';

    document
      .querySelectorAll('[data-essential-cart-element="cart-drawer-empty-button"]')
      .forEach((link) => {
        let pathname;
        try {
          pathname = new URL(link.href, window.location.origin).pathname;
        } catch {
          return;
        }

        if (pathname === '/collections/all' || pathname === '/en/collections/all') {
          link.setAttribute('href', localizedCollectionsUrl);
        }
      });

    if (isUsEnglish && usProductImage) {
      document
        .querySelectorAll(
          'img[data-essential-cart-element="line-item-image"], [data-essential-cart-element="line-item-image"] img'
        )
        .forEach((image) => {
          const source = image.currentSrc || image.src || '';
          if (!source.includes('/nuyva5_chiffon.jpg')) return;

          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.src = usProductImage;
          image.alt = 'Nuyva AquaFibre™ — 5 microfiber cloths';
        });
    }

    document.querySelectorAll('[aria-label*="Shopping cart with 1 items"]').forEach((element) => {
      element.setAttribute(
        'aria-label',
        locale === 'fr' ? 'Panier avec 1 article' : 'Shopping cart with 1 item'
      );
    });

    if (locale !== 'fr') return;

    const textReplacements = new Map([
      ['Regular price:', 'Prix normal :'],
      ['Sale price:', 'Prix promotionnel :'],
      ['Compare-at price:', 'Prix de comparaison :'],
    ]);
    const cartRoot = document.querySelector('#essential-cart-drawer-portal');

    if (cartRoot) {
      const walker = document.createTreeWalker(cartRoot, NodeFilter.SHOW_TEXT);
      let textNode = walker.nextNode();

      while (textNode) {
        const originalText = textNode.nodeValue || '';
        const trimmedText = originalText.trim();
        let replacement = textReplacements.get(trimmedText);

        if (!replacement && trimmedText.startsWith('Regular price:')) {
          replacement = trimmedText.replace(/^Regular price:\s*/, 'Prix normal : ');
        } else if (!replacement && trimmedText.startsWith('Sale price:')) {
          replacement = trimmedText.replace(/^Sale price:\s*/, 'Prix promotionnel : ');
        } else if (!replacement && trimmedText.startsWith('Compare-at price:')) {
          replacement = trimmedText.replace(/^Compare-at price:\s*/, 'Prix de comparaison : ');
        }

        if (replacement) {
          textNode.nodeValue = originalText.replace(trimmedText, replacement);
        }

        textNode = walker.nextNode();
      }
    }

    document.querySelectorAll('#essential-cart-drawer-portal [aria-label]').forEach((element) => {
      const originalLabel = element.getAttribute('aria-label') || '';
      let translatedLabel = originalLabel;

      if (originalLabel === 'Close cart') translatedLabel = 'Fermer le panier';
      else if (originalLabel === 'Item actions') translatedLabel = "Actions de l’article";
      else if (originalLabel === 'Product recommendations') translatedLabel = 'Recommandations de produits';
      else if (originalLabel === 'Cart summary') translatedLabel = 'Récapitulatif du panier';
      else if (originalLabel === 'Discount code') translatedLabel = 'Code promo';
      else if (originalLabel === 'Apply discount code') translatedLabel = 'Appliquer le code promo';
      else if (/^Shopping cart with \d+ items?$/.test(originalLabel)) {
        const count = Number(originalLabel.match(/\d+/)?.[0] || 0);
        translatedLabel = `Panier avec ${count} ${count === 1 ? 'article' : 'articles'}`;
      } else if (originalLabel.startsWith('Select variant for ')) {
        translatedLabel = `Sélectionner une variante pour ${originalLabel.slice(19)}`;
      } else if (originalLabel.startsWith('Remove ') && originalLabel.endsWith(' from cart')) {
        translatedLabel = `Retirer ${originalLabel.slice(7, -10)} du panier`;
      } else if (originalLabel.startsWith('Decrease quantity of ')) {
        translatedLabel = `Réduire la quantité de ${originalLabel.slice(21)}`;
      } else if (originalLabel.startsWith('Increase quantity of ')) {
        translatedLabel = `Augmenter la quantité de ${originalLabel.slice(21)}`;
      } else if (originalLabel.startsWith('Payment icon ')) {
        translatedLabel = `Icône de paiement ${originalLabel.slice(13)}`;
      }

      translatedLabel = translatedLabel.replace(/, quantity (\d+)$/, ', quantité $1');

      if (translatedLabel !== originalLabel) {
        element.setAttribute('aria-label', translatedLabel);
      }
    });
  }

  new MutationObserver(localizeEssentialCartNavigation).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
  document.addEventListener('DOMContentLoaded', localizeEssentialCartNavigation);
  localizeEssentialCartNavigation();
})();

(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  const originalPositions = new WeakMap();
  let timer;
  let applying = false;

  function findLineItem(details) {
    const arrangedActions = details.querySelector(
      ':scope > [data-nuyva-cart-action-row] > [data-essential-cart-element="line-item-actions"]'
    );
    if (arrangedActions) return { item: details, actions: arrangedActions };

    let node = details.parentElement;
    for (let depth = 0; node && depth < 6; depth += 1, node = node.parentElement) {
      const actions = node.querySelector(':scope > [data-essential-cart-element="line-item-actions"]');
      if (actions) return { item: node, actions };
    }
    return null;
  }

  function rememberPosition(element) {
    if (originalPositions.has(element)) return;

    const placeholder = document.createComment('nuyva-cart-original-position');
    element.before(placeholder);
    originalPositions.set(element, {
      parent: placeholder.parentNode,
      nextSibling: placeholder.nextSibling,
      placeholder,
    });
  }

  function moveElement(element, destination) {
    rememberPosition(element);
    destination.append(element);
  }

  function restoreElement(element) {
    const original = originalPositions.get(element);
    if (!original) return false;

    if (original.placeholder.isConnected) {
      original.placeholder.replaceWith(element);
    } else if (original.parent?.isConnected) {
      const nextSibling = original.nextSibling?.parentNode === original.parent ? original.nextSibling : null;
      original.parent.insertBefore(element, nextSibling);
    } else {
      return false;
    }

    originalPositions.delete(element);
    return true;
  }

  function updateSelectedLabel(select, quantityLabel) {
    const selectedLabel = select.selectedOptions[0]?.textContent.trim() || '';
    quantityLabel.textContent = selectedLabel;
    quantityLabel.toggleAttribute('hidden', !selectedLabel);
  }

  function restoreCartItems() {
    document.querySelectorAll('[data-nuyva-cart-selector]').forEach((selector) => {
      if (restoreElement(selector)) selector.removeAttribute('data-nuyva-cart-selector');
    });

    document.querySelectorAll('[data-nuyva-cart-action-moved]').forEach((actions) => {
      if (restoreElement(actions)) actions.removeAttribute('data-nuyva-cart-action-moved');
    });

    document.querySelectorAll('[data-nuyva-cart-action-row], [data-nuyva-cart-selector-row]').forEach((row) => {
      const containsAppControls = row.querySelector(
        '[data-essential-cart-element="line-item-actions"], [data-essential-cart-element="line-item-variant-selector"]'
      );
      if (!containsAppControls) row.remove();
    });
  }

  function arrangeCartItems() {
    if (applying) return;
    applying = true;

    try {
      if (!mobile.matches) {
        restoreCartItems();
        return;
      }

      document
        .querySelectorAll('[data-essential-cart-element="cart-drawer-item-details"]')
        .forEach((details) => {
          const selector = details.querySelector(
            '[data-essential-cart-element="line-item-variant-selector"]'
          );
          const select = selector?.querySelector('select');
          const lineItem = findLineItem(details);
          if (!selector || !select || !lineItem) return;

          selector.setAttribute('data-nuyva-cart-selector', '');
          lineItem.actions.setAttribute('data-nuyva-cart-action-moved', '');

          let row = details.querySelector(':scope > [data-nuyva-cart-action-row]');
          if (!row) {
            row = document.createElement('div');
            row.setAttribute('data-nuyva-cart-action-row', '');
            details.insertBefore(row, selector);
          }

          let selectorRow = details.querySelector(':scope > [data-nuyva-cart-selector-row]');
          if (!selectorRow) {
            selectorRow = document.createElement('div');
            selectorRow.setAttribute('data-nuyva-cart-selector-row', '');
            row.insertAdjacentElement('afterend', selectorRow);
          }

          moveElement(selector, selectorRow);

          let quantityLabel = row.querySelector('[data-nuyva-cart-pack-quantity]');
          if (!quantityLabel) {
            quantityLabel = document.createElement('span');
            quantityLabel.setAttribute('data-nuyva-cart-pack-quantity', '');
            quantityLabel.setAttribute('aria-hidden', 'true');
            row.prepend(quantityLabel);
          }

          moveElement(lineItem.actions, row);
          updateSelectedLabel(select, quantityLabel);
        });
    } finally {
      applying = false;
    }
  }

  function schedule() {
    window.clearTimeout(timer);
    timer = window.setTimeout(arrangeCartItems, 80);
  }

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest(
      '[data-essential-cart-element="line-item-variant-selector"] select'
    );
    if (!select || !mobile.matches) return;

    const details = select.closest('[data-essential-cart-element="cart-drawer-item-details"]');
    const quantityLabel = details?.querySelector('[data-nuyva-cart-pack-quantity]');
    if (quantityLabel) updateSelectedLabel(select, quantityLabel);
  });

  mobile.addEventListener?.('change', schedule);
  document.addEventListener('DOMContentLoaded', schedule);
  schedule();
})();
